module.exports = __webpack_public_path__ + "static/media/AI_Calander_Icon.8b32061c.svg";